(function () {
	const initProductAccordion = () => {
		$(".about__accordion-toggle").click(function () {
			if (!$(this).hasClass("active")) {
				$(this).addClass("active");
				$(this)
					.siblings(".about__accordion-description")
					.eq($(this).index())
					.stop()
					.slideDown(300);
			} else {
				$(this).removeClass("active");
				$(this).siblings(".about__accordion-description").stop().slideUp(300);
			}
		});
	};

	const initZoomImage = () => {
		const imagesWrapper = document.querySelector(
			".product-media-modal__content"
		);
		const images = imagesWrapper.querySelectorAll(".js-image-zoom");

		images.forEach((el) => {
			el.addEventListener("click", (e) => {
				imagesWrapper.classList.toggle("zoom");
			});
		});
	};



	const revealPopup = () => {
		const stickyBar = document.querySelector('.product__popup');
		const footer = document.querySelector('footer');

		if (!stickyBar || !footer) return;

		// Trigger: buy buttons block, fallback a sección del producto
		const triggerEl =
			document.querySelector('.product__buy_buttons') ||
			document.querySelector('.product-section + section') ||
			document.querySelector('[id^="MainProduct-"]') ||
			document.querySelector('main section:first-child');

		if (!triggerEl) return;

		const getOffset = (element) => {
			const rect = element.getBoundingClientRect();
			return rect.top + window.scrollY;
		};

		const triggerOffset = getOffset(triggerEl) + (triggerEl.offsetHeight || 0);
		const footerTop = getOffset(footer);

		const handleScroll = () => {
			const scrollPosition = window.scrollY + window.innerHeight;
			const activeOffset = window.scrollY > triggerOffset && scrollPosition < footerTop;
			stickyBar.classList[activeOffset ? 'add' : 'remove']('active');
		};

		handleScroll();
	};

	const syncSizeSystemPicker = (picker, system = "mx") => {
		if (!picker) return;

		const normalizedSystem = system === "us" ? "us" : "mx";
		picker.dataset.activeSizeSystem = normalizedSystem;

		picker.querySelectorAll("[data-size-system-tab]").forEach((button) => {
			const isActive = button.dataset.sizeSystemTab === normalizedSystem;
			button.classList.toggle("is-active", isActive);
			button.setAttribute("aria-pressed", isActive ? "true" : "false");
		});

		picker.querySelectorAll("[data-size-pill-value]").forEach((labelValue) => {
			const pill = labelValue.closest("[data-size-original]");
			if (!pill) return;

			const nextValue =
				normalizedSystem === "us"
					? pill.dataset.sizeUs || pill.dataset.sizeOriginal
					: pill.dataset.sizeMx || pill.dataset.sizeOriginal;

			labelValue.textContent = nextValue || pill.dataset.sizeOriginal || "";
			pill.setAttribute("title", nextValue || pill.dataset.sizeOriginal || "");
		});
	};

	const initSizeSystemPickers = (root = document) => {
		root.querySelectorAll("[data-size-system-picker]").forEach((picker) => {
			syncSizeSystemPicker(picker, picker.dataset.activeSizeSystem || "mx");
		});
	};

	document.addEventListener("click", (event) => {
		const toggleButton = event.target.closest("[data-size-system-tab]");
		if (!toggleButton) return;

		const picker = toggleButton.closest("[data-size-system-picker]");
		if (!picker) return;

		syncSizeSystemPicker(picker, toggleButton.dataset.sizeSystemTab);
	});
	document.addEventListener('scroll', () => revealPopup());


	document.addEventListener("shopify:section:load", function () {
		initProductAccordion();
		initZoomImage();
		revealPopup();
		initSizeSystemPickers();
	});

	initProductAccordion();
	initZoomImage();
	revealPopup();
	initSizeSystemPickers();

	window.initSizeSystemPickers = initSizeSystemPickers;
})();

class FloatedForm extends HTMLElement {
	constructor() {
		super();
		this.renderForm();
	}

	renderForm() {
		fetch(this.getAttribute("data-product-url"))
			.then((response) => response.text())
			.then((responseText) => {
				const responseHTML = new DOMParser().parseFromString(
					responseText,
					"text/html"
				);
				this.productElement = responseHTML.querySelector(
					'div[id^="ProductInfo-"]'
				);

				this.preventDuplicatedIDs();
				this.removeDOMElements();
				this.setInnerHTML(this, this.productElement.innerHTML);

				if (window.Shopify && Shopify.PaymentButton) {
					Shopify.PaymentButton.init();
				}

				if (window.ProductModel) window.ProductModel.loadShopifyXR();

				this.showMoreFields();
				window.initSizeSystemPickers?.(this);
			})
			.finally(() => {
				const selectDropDown = () => {
					$(".product__popup .product-form__controls--dropdown").each(function () {
						const elListItem = $(this).find(".dropdown-select ul li");
						const elItem = $(this).find(".dropdown-select ul");
						const selectedText = $(this).find(
							".dropdown-select .select-label"
						);

						selectedText.on("click", function (e) {
							elItem.toggleClass("active");
							if (elItem.hasClass("active")) {
								e.stopPropagation();
								$(document).click(function () {
									elItem.removeClass("active");
								});
							}
						});

						elListItem.on("click", function () {
							selectedText
								.find("span")
								.text($(this).text())
								.attr("title", $(this).text());
							elItem.removeClass("active");
							document.activeElement.blur();
						});
					});
				};

				selectDropDown();
			});
	}

	setInnerHTML(element, html) {
		element.innerHTML = html;

		// Reinjects the script tags to allow execution. By default, scripts are disabled when using element.innerHTML.
		element.querySelectorAll("script").forEach((oldScriptTag) => {
			const newScriptTag = document.createElement("script");
			Array.from(oldScriptTag.attributes).forEach((attribute) => {
				newScriptTag.setAttribute(attribute.name, attribute.value);
			});
			newScriptTag.appendChild(document.createTextNode(oldScriptTag.innerHTML));
			oldScriptTag.parentNode.replaceChild(newScriptTag, oldScriptTag);
		});
	}

	preventDuplicatedIDs() {
		const sectionId = this.productElement.dataset.section;
		this.productElement.innerHTML = this.productElement.innerHTML.replaceAll(
			sectionId,
			`floated-${sectionId}`
		);

		if (this.productElement.querySelectorAll("variant-selects")) {
			this.productElement
				.querySelectorAll("variant-selects")
				.forEach((radio) => {
					radio.dataset.originalSection = sectionId;
				});
		}

		if (this.productElement.querySelectorAll("variant-radios")) {
			this.productElement
				.querySelectorAll("variant-radios")
				.forEach((radio) => {
					radio.dataset.originalSection = sectionId;
				});
		}
	}

	removeDOMElements() {
		const text = this.productElement.querySelector(".product__text");
		if (text) text.remove();

		const tags = this.productElement.querySelector(".product__tags");
		if (tags) tags.remove();

    const title = this.productElement.querySelector(".product__title__wrapper");
		if (title) title.remove();

		const badges = this.productElement.querySelector(".product__custom-badges");
		if (badges) badges.remove();

    const price = this.productElement.querySelector(".price-wrapper");
		if (price) price.remove();

		const description = this.productElement.querySelector(
			".product__description"
		);
		if (description) description.remove();

		const sku = this.productElement.querySelector(".product__sku");
		if (sku) sku.remove();

		const inventory = this.productElement.querySelector(".product__inventory");
		if (inventory) inventory.remove();

		const pickupAvailability = this.productElement.querySelector(
			"pickup-availability"
		);
		if (pickupAvailability) pickupAvailability.remove();

		const customLiquid = this.productElement.querySelector(".custom-liquid");
		if (customLiquid) customLiquid.remove();

		const complementary = this.productElement.querySelector(
			"product-recommendations"
		);
		if (complementary) complementary.remove();

		const shareButtons = this.productElement.querySelector(".share-buttons");
		if (shareButtons) shareButtons.remove();

		const productModal = this.productElement.querySelectorAll(".product-popup");
		productModal.forEach((advantage) => {
			advantage.remove();
		});

		const productForm = this.productElement.querySelector("floated-form");
		if (productForm) productForm.remove();
	}

	showMoreFields() {
		$(".js-show-more").click(function (e) {
			e.preventDefault();
			$(this).siblings("input").removeClass("hidden");
			$(this).siblings("label").removeClass("hidden");
			$(this).remove();
		});
	}
}

customElements.define("floated-form", FloatedForm);

const initMorkasMobileMediaGalleries = (scope = document) => {
	scope.querySelectorAll(".product__outer--mobile-snap-gallery").forEach((gallery) => {
		if (gallery.dataset.mobileGalleryReady === "true") return;

		const track = gallery.querySelector(".morkas-mobile-media-track");
		const progress = gallery.querySelector(".morkas-mobile-media-progress");
		if (!track || !progress) return;

		const slides = Array.from(track.children).filter((item) =>
			item.classList.contains("product__media-item")
		);
		const current = progress.querySelector("[data-mobile-media-current]");
		const total = progress.querySelector("[data-mobile-media-total]");
		if (slides.length < 2 || !current || !total) return;

		gallery.dataset.mobileGalleryReady = "true";
		progress.style.setProperty("--media-total", slides.length);
		total.textContent = slides.length;

		let frame;
		const updateProgress = () => {
			const slideWidth = track.clientWidth || 1;
			const index = Math.max(
				0,
				Math.min(slides.length - 1, Math.round(track.scrollLeft / slideWidth))
			);

			current.textContent = index + 1;
			progress.style.setProperty("--media-index", index);
		};

		track.addEventListener(
			"scroll",
			() => {
				window.cancelAnimationFrame(frame);
				frame = window.requestAnimationFrame(updateProgress);
			},
			{ passive: true }
		);

		track.addEventListener("keydown", (event) => {
			if (event.key !== "ArrowLeft" && event.key !== "ArrowRight") return;

			event.preventDefault();
			const direction = event.key === "ArrowRight" ? 1 : -1;
			const currentIndex = Math.round(track.scrollLeft / (track.clientWidth || 1));
			const nextIndex = Math.max(0, Math.min(slides.length - 1, currentIndex + direction));
			slides[nextIndex].scrollIntoView({
				behavior: window.matchMedia("(prefers-reduced-motion: reduce)").matches ? "auto" : "smooth",
				block: "nearest",
				inline: "start",
			});
		});

		window.addEventListener("resize", updateProgress, { passive: true });
		updateProgress();
	});
};

document.addEventListener("DOMContentLoaded", () => initMorkasMobileMediaGalleries());
document.addEventListener("shopify:section:load", (event) =>
	initMorkasMobileMediaGalleries(event.target)
);

const initMorkasPdpConversionTools = (scope = document) => {
	const productSections = scope.matches?.('[id^="MainProduct-"]')
		? [scope]
		: scope.querySelectorAll('[id^="MainProduct-"]');

	productSections.forEach((section) => {
		if (section.dataset.morkasConversionReady === "true") return;

		const sticky = section.querySelector("[data-morkas-sticky-atc]");
		const primaryButton = section.querySelector(".product-form__submit");
		const gallery = section.querySelector(".product__media-wrapper");
		const footer = document.querySelector("footer");
		if (!sticky || !primaryButton || !gallery) return;

		section.dataset.morkasConversionReady = "true";
		const stickyButton = sticky.querySelector("[data-morkas-sticky-submit]");
		const stickyPrice = sticky.querySelector("[data-morkas-sticky-price]");
		const stickyVariant = sticky.querySelector("[data-morkas-sticky-variant]");
		let primaryVisible = true;
		let footerVisible = false;

		const modalIsOpen = () =>
			Boolean(document.querySelector("modal-dialog[open], .product-popup-modal[open], cart-drawer[open], menu-drawer[open]"));

		const selectedSize = () => {
			const checked = section.querySelector("[data-size-system-picker] input:checked");
			if (!checked) return "";
			const label = section.querySelector(`label[for="${checked.id}"] [data-size-pill-value]`);
			return label?.textContent.trim() || checked.value.split(" ")[0] || "";
		};

		const syncStickyContent = () => {
			const price = section.querySelector(".price-wrapper .price--product");
			const salePrice = price?.querySelector(".price__sale .price-item--sale");
			const regularPrice = price?.querySelector(".price__regular .price-item--regular");
			const buttonLabel = primaryButton.querySelector("span")?.textContent.trim();
			const size = selectedSize();

			if (stickyPrice) {
				stickyPrice.textContent = (salePrice || regularPrice)?.textContent.replace(/\s+/g, " ").trim() || "";
			}
			if (stickyVariant) stickyVariant.textContent = size ? `Talla ${size}` : "Elige tu talla";
			stickyButton.disabled = primaryButton.disabled;
			stickyButton.querySelector("span").textContent = buttonLabel || (primaryButton.disabled ? "Agotado" : "Añadir al carrito");
		};

		const updateStickyVisibility = () => {
			const galleryThreshold = gallery.offsetTop + gallery.offsetHeight * 0.55;
			const passedGallery = window.scrollY > galleryThreshold;
			const shouldShow = window.innerWidth < 750 && passedGallery && !primaryVisible && !footerVisible && !modalIsOpen();

			sticky.hidden = !shouldShow;
			document.body.classList.toggle("morkas-sticky-atc-visible", shouldShow);
		};

		const primaryObserver = new IntersectionObserver(
			(entries) => {
				primaryVisible = entries[0]?.isIntersecting ?? true;
				updateStickyVisibility();
			},
			{ threshold: 0.15 }
		);
		primaryObserver.observe(primaryButton);

		if (footer) {
			const footerObserver = new IntersectionObserver((entries) => {
				footerVisible = entries[0]?.isIntersecting ?? false;
				updateStickyVisibility();
			});
			footerObserver.observe(footer);
		}

		const contentObserver = new MutationObserver(syncStickyContent);
		contentObserver.observe(primaryButton, { attributes: true, childList: true, subtree: true });

		section.addEventListener("change", () => window.setTimeout(syncStickyContent, 0));
		document.addEventListener("variant:change", () => {
			window.setTimeout(syncStickyContent, 0);
			window.setTimeout(syncStickyContent, 500);
		});
		window.addEventListener("scroll", updateStickyVisibility, { passive: true });
		window.addEventListener("resize", updateStickyVisibility, { passive: true });
		document.addEventListener("click", () => window.setTimeout(updateStickyVisibility, 100));

		syncStickyContent();
		updateStickyVisibility();
	});

	scope.querySelectorAll("[data-morkas-review-link]").forEach((button) => {
		if (button.dataset.morkasReviewReady === "true") return;
		button.dataset.morkasReviewReady = "true";
		button.addEventListener("click", () => {
			const reviews = document.querySelector("[data-home-reviews], #rlt-cont");
			if (!reviews) return;
			reviews.scrollIntoView({
				behavior: window.matchMedia("(prefers-reduced-motion: reduce)").matches ? "auto" : "smooth",
				block: "start",
			});
		});
	});
};

document.addEventListener("DOMContentLoaded", () => initMorkasPdpConversionTools());
document.addEventListener("shopify:section:load", (event) => initMorkasPdpConversionTools(event.target));
